module.exports = __webpack_public_path__ + "img/facebook.1e590b45.svg";